module.exports = __webpack_public_path__ + "static/media/section-3.5a9035bd.svg";